import { put, delay } from 'redux-saga/effects'
import { resetDigitalStoreStateOnChangeSuccess } from '../actions'

export const DELAY = 500

export function* resetDigitalStoreStateOnChange() {
  yield delay(DELAY)
  yield put(resetDigitalStoreStateOnChangeSuccess())
}
